import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Error = styled.span`
  color: #940420;
  display: block;
  font-size: 12px;
  margin-top: 8px;
`;

const StyledIcon = styled.i`
  color: #940420;
  margin-top: 8px;
`;

const Container = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InputError = ({ message, icon = null, show = true }) => {
  if (!show) return null;

  return (
    <Container>
      {icon && <StyledIcon className="fa fa-times-circle fa-1x" />}
      <Error>{message}</Error>
    </Container>
  );
};

InputError.defaultProps = {
  icon: null,
  show: true,
};

export default InputError;

InputError.propTypes = {
  /* HTML: The primary error text */
  message: PropTypes.node.isRequired,
  /* JSX: Controls rendering of an icon */
  icon: PropTypes.bool,
  /* Render nothing when false, so callers can inline the condition */
  show: PropTypes.bool,
};
